import singleImage from './singleImage.vue'
export default singleImage